import React from 'react';

import PreChatContainer from '../ui/PreChatContainer';
import PreChatHeader from '../ui/PreChatHeader';
import InfoCardGrid from '../ui/InfoCardGrid';
import InfoCard from '../ui/InfoCard';
import BulletList from '../ui/BulletList';

const ClaimReview: React.FC = () => {
    const analyzeItems = [
        'Medical claims (CMS-1500, UB-04)',
        'EDI files (837 Professional/Institutional)',
        'PDF claims and scanned documents',
        'Claim screenshots or images'
    ];

    const validateItems = [
        'Required field completion',
        'CPT/HCPCS and ICD-10 code accuracy',
        'Payer-specific requirements',
        'Documentation completeness',
        'Estimated approval probability'
    ];

    return (
        <PreChatContainer>
            <PreChatHeader
                icon="/assets/claim-review.png"
                iconAlt="Claim Review"
                title="Claim Review"
                description="I'll help you validate your claim and provide improvement suggestions."
                instructions="Please attach your claim file using the paperclip icon in the chatbox below or drag & drop it here."
            />

            <InfoCardGrid>
                <InfoCard title="I can analyze the following:">
                    <BulletList items={analyzeItems} />
                </InfoCard>
                <InfoCard title="What I'll validate:">
                    <BulletList items={validateItems} />
                </InfoCard>
            </InfoCardGrid>
        </PreChatContainer>
    );
};

export default ClaimReview;



